import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCVXpCE-r_-e377tChSHOzzEUfUsGv5TMY",
  authDomain: "nvoiceapp-e747d.firebaseapp.com",
  projectId: "nvoiceapp-e747d",
  storageBucket: "nvoiceapp-e747d.appspot.com",
  messagingSenderId: "932270853663",
  appId: "1:932270853663:web:70e574042ee320ea69cf2a"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app); 
export default app;